export default __webpack_public_path__ + "static/media/error-illustration.d52bf6ea.svg";